import React from "react";
import styled from "styled-components";

function Navbar() {
  return (
    <Container>
      <LogoSection>
        <img src="./logo (1).png" alt="" />
      </LogoSection>
      <MenuSection>
        <p>Home</p>
        <p>Menu</p>
        <p>Service</p>
        <p>Shop</p>
      </MenuSection>
      <SearchBar>
        <SearchIcon>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2124 14.5735L11.4044 10.6129C12.3835 9.44901 12.92 7.98455 12.92 6.45999C12.92 2.89801 10.022 0 6.45999 0C2.89801 0 0 2.89801 0 6.45999C0 10.022 2.89801 12.92 6.45999 12.92C7.79721 12.92 9.07152 12.5167 10.161 11.751L13.998 15.7416C14.1583 15.9082 14.374 16 14.6052 16C14.824 16 15.0316 15.9166 15.1891 15.7649C15.5239 15.4428 15.5346 14.9085 15.2124 14.5735ZM6.45999 1.68522C9.09286 1.68522 11.2348 3.82713 11.2348 6.45999C11.2348 9.09286 9.09286 11.2348 6.45999 11.2348C3.82713 11.2348 1.68522 9.09286 1.68522 6.45999C1.68522 3.82713 3.82713 1.68522 6.45999 1.68522Z"
              fill="#8B8B8B"
            />
          </svg>
        </SearchIcon>
        <input type="text" placeholder="Search .." />
        <BasketIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.01408 10.0841C0.9409 9.79136 1.16228 9.50781 1.46398 9.50781H22.536C22.8377 9.50781 23.0591 9.79136 22.986 10.0841L20.0593 21.7903C19.9561 22.2032 19.5851 22.4928 19.1595 22.4928H4.84044C4.41484 22.4928 4.04385 22.2032 3.94063 21.7903L1.01408 10.0841ZM12.75 13.6253C12.75 13.2111 12.4142 12.8753 12 12.8753C11.5858 12.8753 11.25 13.2111 11.25 13.6253V18.3753C11.25 18.7895 11.5858 19.1253 12 19.1253C12.4142 19.1253 12.75 18.7895 12.75 18.3753V13.6253ZM17.0688 13.0638C17.458 13.2055 17.6588 13.6359 17.517 14.0251L15.8925 18.4886C15.7508 18.8779 15.3204 19.0786 14.9312 18.9369C14.542 18.7952 14.3413 18.3648 14.483 17.9756L16.1075 13.5121C16.2492 13.1228 16.6796 12.9221 17.0688 13.0638ZM7.89245 13.5121C7.7508 13.1228 7.3204 12.9221 6.9312 13.0638C6.54195 13.2055 6.34125 13.6359 6.48295 14.0251L8.1075 18.4886C8.2492 18.8779 8.6796 19.0786 9.0688 18.9369C9.45805 18.7952 9.65875 18.3648 9.51705 17.9756L7.89245 13.5121Z"
              fill="#3C3737"
            />
            <path
              d="M18.5 10.5L13.5887 4.07758C12.7882 3.03078 11.2118 3.03078 10.4113 4.07758L5.5 10.5"
              stroke="#3C3737"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </BasketIcon>
      </SearchBar>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 67px;
  width: 90%;
  justify-content: space-evenly;
  margin-top: 15px;
  margin: 15px auto;
`;
const LogoSection = styled.div``;
const MenuSection = styled.div`
  display: flex;
  align-items: center;
  width: 500px;
  justify-content: space-evenly;

  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #4d4d4d;
    cursor: pointer;

    &:nth-child(1) {
      color: #f55253;
    }
  }
  @media only screen and (max-width: 767px) {
    /* Styles */
    display: none;
  }
`;
const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  width: 250px;
  position: relative;
  height: 40px;
  padding: 0 10px;
  justify-content: center;

  input {
    height: 30px;
    border: none;
    outline: none;
    padding: 0 10px;
    width: 90%;
  }
  @media only screen and (max-width: 767px) {
    /* Styles */
    display: none;
  }
`;

const SearchIcon = styled.div``;

const BasketIcon = styled.div`
  margin-left: 10px;

  &::before {
    content: "2";
    background: #f54b4b;
    box-shadow: -6px 9px 24px -6px rgba(238, 67, 67, 0.68);
    width: 20px;
    height: 20px;
    font-size: 14px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    top: -10px;
    right: 0;
    border-radius: 100%;
  }
`;
export default Navbar;
